import React from "react";
import { Row, Col } from "antd";
import "./PropertyType.css";
import { LuBuilding2 } from "react-icons/lu";
import { BsBuilding } from "react-icons/bs";
import { FiHome } from "react-icons/fi";
import { FaRegMap } from "react-icons/fa";
import { useBreakpoints } from "./ResponsiveBreakPoints";

const propertyTypes = [
  {
    title: "Builder Floors",
    description:
      "Independent floors with modern amenities in prime locations",
    icon: <LuBuilding2 />,
  },
  {
    title: "New Projects",
    description:
      "Latest residential projects from top developers",
    icon: <BsBuilding />,
  },
  {
    title: "Independent Homes",
    description:
      "Standalone houses with privacy and space",
    icon: <FiHome />,
  },
  {
    title: "Plots & Land",
    description:
      "Investment-ready plots for your dream construction",
    icon: <FaRegMap />,
  },
];

const PropertyTypes = () => {
  const { isSuperLarge } = useBreakpoints();

  return (
    <Row
      justify="center"
      className="property-section"
    >
      {/* 🔹 Main container (same pattern as AboutUs) */}
      <Col
        xs={22}
        sm={22}
        md={22}
        lg={18}
        xl={20}
        xxl={16}
        style={{ maxWidth: isSuperLarge ? "50%" : "" }}
      >
        {/* Heading */}
        <h2 className="property-heading">Explore Property Types</h2>
        <p className="property-subheading">
          Whether you're looking for your first home or next investment,
          we've got you covered.
        </p>

        {/* Cards */}
        <Row gutter={[24, 24]}>
          {propertyTypes.map((item, index) => (
            <Col
              key={index}
              xs={24}
              sm={12}
              md={12}
              lg={6}
            >
              <div className="property-card">
                <div className="property-icon">{item.icon}</div>
                <h3 className="property-title">{item.title}</h3>
                <p className="property-text">{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};

export default PropertyTypes;
